import { render, staticRenderFns } from "./LoadingDataLoader.vue?vue&type=template&id=edb22c3c&"
import script from "./LoadingDataLoader.vue?vue&type=script&lang=js&"
export * from "./LoadingDataLoader.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDataLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports